import React from 'react';
import { STUDIO_COPY } from '../config';

type ReconnectTwitchCardProps = {
  onReconnect: () => void;
};

/** Friendly reconnect state — not a hard error. */
const ReconnectTwitchCard: React.FC<ReconnectTwitchCardProps> = ({
  onReconnect,
}) => {
  return (
    <div
      className="studio-panel space-y-5"
      data-testid="studio-reconnect-card"
      role="status"
    >
      <div className="studio-tape-stripe rounded-sm opacity-70" aria-hidden />
      <h2 className="text-2xl font-semibold">{STUDIO_COPY.reconnectHeadline}</h2>
      <p className="studio-prose text-[var(--studio-muted)] leading-relaxed">
        {STUDIO_COPY.reconnectBody}
      </p>
      <button
        type="button"
        className="studio-btn-primary"
        onClick={onReconnect}
        data-testid="studio-reconnect-cta"
      >
        {STUDIO_COPY.reconnectCta}
      </button>
    </div>
  );
};

export default ReconnectTwitchCard;
